module.exports = __webpack_public_path__ + "img/icon_change_avatar.8abe9f29.svg";